export default __webpack_public_path__ + "static/media/vip-3.3edcddb2.webp";